import {
    PROMOTION_BY_REVENUE_SUCCESS,
    PROMOTION_BY_REVENUE_LOADING,
    TABLE_LOADING
} from '../actions/PromotionByRevenueAction';

const initialState = {
    promotionData: null,
    isLoading: true,
    isTableLoading: true
};

const OrderReducer = (state = initialState, action = {}) => {
    switch (action.type) {
        case PROMOTION_BY_REVENUE_SUCCESS:
            return { ...state, promotionData: action.data, isLoading: false, isTableLoading: false };
        case PROMOTION_BY_REVENUE_LOADING:
            return { ...state, isLoading: action.isLoading };
        case TABLE_LOADING:
                return { ...state, isTableLoading: action.isTableLoading };

        default:
            return state;
    }
};

export default OrderReducer;